import { redirect } from "react-router-dom";
import { AuthError } from "@/types/errorTypes/authError";
import { apiEndpoints } from "@/services/api/api.ts";
import { DiscountTypeEnum } from "@/routes/lecturer/routes/discountCode/main/types/discountTypeEnum.ts";
import { ParseHelper } from "@/services/helpers/parseHelper.ts";
import { AdminPanelDiscountCodeData } from "@/routes/adminPanel/discountCodes/main/types/adminPanelDiscountCodeData.ts";

const parseDiscountType = (value: string | number): DiscountTypeEnum => {
  const numValue =
    typeof value === "string" ? Number.parseInt(value, 10) : value;

  if (isNaN(numValue) || !Object.values(DiscountTypeEnum).includes(numValue)) {
    return DiscountTypeEnum.Percentage; // Default fallback
  }

  return numValue as DiscountTypeEnum;
};

export const adminPanelDiscountCodeEditAction = async ({
  request,
}: {
  request: Request;
}) => {
  try {
    const formData = await request.formData();
    const rawData = Object.fromEntries(
      formData,
    ) as unknown as AdminPanelDiscountCodeData;

    // Parse and validate form data
    const code = rawData.code?.trim().toUpperCase() || "";
    const type = parseDiscountType(rawData.type);
    const discountValue = ParseHelper.parseNumber(rawData.discountValue) ?? 0;

    // Process the data
    const processedData: AdminPanelDiscountCodeData = {
      ...rawData,
      code,
      type,
      discountValue: type === DiscountTypeEnum.Free ? 0 : discountValue,
      isBasketDiscount: ParseHelper.parseBoolean(rawData.isBasketDiscount),
      applyOnDiscountedPrice: ParseHelper.parseBoolean(
        rawData.applyOnDiscountedPrice,
      ),
      isReusable: ParseHelper.parseBoolean(rawData.isReusable),
      courseId: rawData.courseId || null,
    };

    // Get return URL
    const url = new URL(request.url);
    const returnUrl =
      url.searchParams.get("returnUrl") || "/admin-panel/discount-codes";

    // Make API call
    const result = await apiEndpoints.updateAdminDiscountCode(processedData);

    if (result.success) {
      return redirect(returnUrl);
    } else {
      return {
        success: false,
        error: result.message || "İndirim kodu güncellenirken bir hata oluştu",
      };
    }
  } catch (err) {
    const error = err as AuthError;
    const errorMessage = error.message || "Invalid credentials";
    return {
      success: false,
      error: errorMessage,
    };
  }
};
